import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Toaster } from "@td/ui";
import { translate } from "@td/shared_utils";
import { EditButton, Container } from "../components";
import InitialStateProvider, { useInitialState } from "../contexts/initial-state-context";
import CurrentStatus from "./CurrentStatus";
import PreIntakeStatusForm from "./PreIntakeStatusForm";

const PreIntakeStatus = React.memo(() => {
  const { consultation: { preIntakeStatusCode } } = useInitialState();
  const [editMode, setEditMode] = useState(false);

  useEffect(() => setEditMode(!preIntakeStatusCode), [preIntakeStatusCode]);

  const handleEditClick = useCallback(() => setEditMode(true), []);
  const handleCloseClick = useCallback(() => setEditMode(false), []);

  return (
    <Container>
      {editMode ? (
        <PreIntakeStatusForm
          onCancel={handleCloseClick}
        />
      ) : (
        <React.Fragment>
          <CurrentStatus />

          <EditButton onClick={handleEditClick}>
            {translate(null, "pre_intake.actions", "edit")}
          </EditButton>
        </React.Fragment>
      )}
    </Container>
  );
});

PreIntakeStatus.displayName = "PreIntakeStatus";

const PreIntakeStatusInitializer = React.memo(({ consultationId }) => (
  <InitialStateProvider consultationId={consultationId}>
    <PreIntakeStatus />
    <Toaster />
  </InitialStateProvider>
));

PreIntakeStatusInitializer.displayName = "PreIntakeStatusInitializer";
PreIntakeStatusInitializer.propTypes = {
  consultationId: PropTypes.string.isRequired,
};

export default PreIntakeStatusInitializer;
